import { render } from "./DSTPreview.vue?vue&type=template&id=536fa314"
import script from "./DSTPreview.vue?vue&type=script&lang=js"
export * from "./DSTPreview.vue?vue&type=script&lang=js"

import "./DSTPreview.vue?vue&type=style&index=0&id=536fa314&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__